/**
 * @generated SignedSource<<16ef6897b9c070e6455e3a54aacdc08e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type searchGraphCode_AtlassianSearchPage$data = {
  readonly __typename: "SearchResultGraphCode";
  readonly description: string;
  readonly id: string;
  readonly language: string | null;
  readonly lastModifiedDate: string | null;
  readonly path: string;
  readonly repository: {
    readonly name: string;
    readonly namespace: string;
    readonly url: string;
  };
  readonly title: string;
  readonly url: string;
  readonly " $fragmentType": "searchGraphCode_AtlassianSearchPage";
};
export type searchGraphCode_AtlassianSearchPage$key = {
  readonly " $data"?: searchGraphCode_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchGraphCode_AtlassianSearchPage">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "url"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "searchGraphCode_AtlassianSearchPage",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "title"
    },
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "name": "path"
    },
    {
      "kind": "ScalarField",
      "name": "description"
    },
    {
      "kind": "ScalarField",
      "name": "language"
    },
    {
      "kind": "ScalarField",
      "name": "lastModifiedDate"
    },
    {
      "concreteType": "SearchResultCodeRepository",
      "kind": "LinkedField",
      "name": "repository",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "name"
        },
        {
          "kind": "ScalarField",
          "name": "namespace"
        },
        (v0/*: any*/)
      ]
    }
  ],
  "type": "SearchResultGraphCode"
};
})();

(node as any).hash = "9b76cff8a1c85b451f09fe74d988a636";

export default node;
